import { DaoModel } from '@dynameat/models';

export class SaleLocation extends DaoModel {
  constructor(guid, externalId, qrCode) {
    super(guid);
    this.externalId = externalId || '';
    this.qrCode = qrCode || null;
  }

  static toInstance(props = {}) {
    return new SaleLocation(props.guid, props.external_id, props.qr_code);
  }

  serialize() {
    return {
      ...super.serialize(),
      external_id: this.externalId,
      qr_code: this.qrCode
    };
  }
}
